import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  position: relative;

  ${breakpoints.up('md')} {
    display: flex;
    align-items: center;
    height: 100%;
  }

  ${breakpoints.down('sm')} {
    margin-bottom: 25px;
  }

  .left-section {
    &__subtitle {
      position: absolute;
      bottom: 100%;
      left: 0;
      margin-bottom: 25px;

      ${breakpoints.down('sm')} {
        position: static;
        margin-bottom: 40px;
      }
    }
  }
`;

export default Container;
